import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LanguageService } from 'src/app/services';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-terms',
    templateUrl: './terms.component.html',
    styleUrls: ['./terms.component.scss'],
    standalone: true,
    imports: [NgIf]
})
export class TermsComponent implements OnDestroy {
    isEnglish: boolean;
    subscription: Subscription;

  constructor(
    private languageService : LanguageService,
    ) {
    this.isEnglish = this.languageService.get() === "fr-FR" ? false : true;
    this.subscription = this.languageService.langEmitter.subscribe(el => this.isEnglish = el == "fr-FR" ? false : true);
  }

  ngOnDestroy(): void {
      this.subscription.unsubscribe();
  }
}
